import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

import { BottomSheetInfo } from '../../services/usePaymentService';

interface Props {
  bottomSheetInfo: BottomSheetInfo[];
}

export const PaymentBottomSheetInfo: React.FC<React.PropsWithChildren<Props>> = ({ bottomSheetInfo }) => {
  return (
    <Info>
      <Header className={Typography.BODY_18_SEMIBOLD}>결제혜택</Header>
      {bottomSheetInfo.map(({ title, content }, index) => (
        <Benefit key={index}>
          <Title>{title}</Title>
          <Contents>
            {content.map((s) => (
              <Content key={s} dangerouslySetInnerHTML={{ __html: s }} />
            ))}
          </Contents>
        </Benefit>
      ))}
    </Info>
  );
};

const Info = styled.div`
  overflow: hidden;
`;

const Header = styled.div`
  margin: 0 0 15px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 22px;
`;

const Benefit = styled.div`
  margin: 10px 0 0 0;
  border: 1px solid ${vars.v3Color.gray150};
  border-radius: 6px;
`;

const Title = styled.div`
  padding: 17px 19px 16px 19px;
  font-size: 15px;
  font-weight: 600;
  color: ${vars.v3Color.gray950};
  background-color: ${vars.v3Color.gray50};
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
`;

const Contents = styled.div`
  margin: 16px 0 0 0;
  padding: 0 19px 19px 23px;
`;

const Content = styled.div`
  margin: 5px 0 0 0;
  font-size: 13px;
  font-weight: 400;
  text-indent: -4px;
  line-height: 16px;
  color: ${vars.v3Color.gray600};
  word-break: keep-all;

  &:before {
    content: '∙ ';
    display: inline-block;
    margin: 0 3px 0 0;
    width: 4px;
  }
`;
